export function rescale(inMax: number, outMax: number, value: number, inMin = 0, outMin = 0) {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}
export default rescale
